import React from 'react';
import { tomos } from '../data/megaPack';
const loop = [...tomos, ...tomos];
export function TomoCovers() {
  return <div className="cover-stage relative -mx-5 overflow-hidden py-6 sm:-mx-8 sm:py-8" aria-label="Portadas de los 7 tomos" data-id="element-282" data-mp="11ny2ualggvo4">
      <div className="cover-track flex w-max items-center gap-4 sm:gap-7" data-id="element-283" data-mp="16ocavsn245m5">
        {loop.map((tomo, index) => <figure key={`${tomo.code}-${index}`} className="cover-card w-[8.5rem] shrink-0 sm:w-[11.5rem] lg:w-[13.5rem]" style={{
        animationDelay: `${index % tomos.length * 1.4}s`
      }} data-id="element-284" data-mp="1gk5m98p1ht2c" data-mpi={index}>
            <img src={tomo.cover} alt={index < tomos.length ? `Portada del ${tomo.code.replace('T', 'Tomo ')}: ${tomo.title}` : ''} aria-hidden={index >= tomos.length} className="h-auto w-full rounded-lg shadow-lift ring-1 ring-ink/10" loading="lazy" width={1130} height={1600} data-id="element-285" data-mp="1pdijgmu4zgu8" />
          </figure>)}
      </div>
    </div>;
}